import '../ExternalAuthorizationForm/ExternalAuthorizationForm.scss';

import React, { useEffect, useRef, useState } from 'react';
import If from 'components/shared/If/If';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import {
  REQUEST_STATE_ERROR,
  REQUEST_STATE_RECEIVED,
  REQUEST_STATE_REQUESTED
} from 'state/requests/RequestStatusReducer';
import { postExternalRetailTrac } from 'services/Rest';
import { Redirect } from 'react-router-dom';
import { ssoAuthTokenUrls } from 'services/Externals';

const ExternalAuthorizationTracForm = () => {
  const [reqStatus, setReqStatus] = useState(null);
  const [responseData, setResponseData] = useState({
    containerApplicationUrl: '',
    cz: '',
    tidx: '',
    token: ''
  });

  const { containerApplicationUrl, cz, tidx, token } = responseData;
  const ssoActivityNoteUrl = ssoAuthTokenUrls.ssoActivityNoteUrl
  const ssoReturnUrl = ssoAuthTokenUrls.ssoReturnUrl
  const formRef = useRef();

  const SSORequestSpinner = () => (
    <div className="sso-form-overlay">
      <p className="sso-form-loading-message"> Authorizing Account </p>
      <Spinner />
    </div>
  );

  const postExternalAuth = (body) =>
    postExternalRetailTrac(body)
      .then(({ assertionText: token, containerApplicationUrl, cz, tidx }) => {
        setReqStatus(REQUEST_STATE_RECEIVED);
        setResponseData({
          containerApplicationUrl,
          cz,
          tidx,
          token
        });
      })
      .catch(() => setReqStatus(REQUEST_STATE_ERROR));

  useEffect(() => {
    const VENDOR_ID = 2002;

    setReqStatus(REQUEST_STATE_REQUESTED);
    let requestBody = {
      serviceTypeId: `${VENDOR_ID}`,
      errorUrl: ssoAuthTokenUrls.errorUrl
    };

    postExternalAuth(requestBody);
  }, []);

  useEffect(() => {
    const isSuccessfulRequest = reqStatus === REQUEST_STATE_RECEIVED;
    if (isSuccessfulRequest && containerApplicationUrl) {
      formRef?.current?.submit();
    }
  }, [reqStatus, containerApplicationUrl]);

  return (
    <div>
      <If test={reqStatus === REQUEST_STATE_REQUESTED}>
        <SSORequestSpinner />
      </If>
      <If test={reqStatus === REQUEST_STATE_ERROR}>
        <Redirect
          to={{
            pathname: '/smallbusiness-unavailable',
          }}
        />
      </If>
      <div className="sso-form-container">
        <div className="sso-form-overlay-blur" />
        <form
          ref={formRef}
          name="trac_sso_form"
          method="POST"
          action={containerApplicationUrl}>
          {token && <input type="hidden" name="SAMLResponse" value={token} />}
          {cz.length && <input type="hidden" name="cz" value={cz} />}
          {tidx.length && <input type="hidden" name="tidx" value={tidx} />}
          {<input type="hidden" name="ssoActivityNotesOn" value="true" />}
          {<input type="hidden" name="ssoActivityNoteUrl" value={ssoActivityNoteUrl} />}
          {<input type="hidden" name="ssoReturnUrl" value={ssoReturnUrl} />}
          {<input type="hidden" name="ssoPresentationType" value="FROM_PRI_VIEW" />}
        </form>
      </div>
    </div>
  );
};

export default ExternalAuthorizationTracForm;
